import * as THREE from 'three';

// Loader
// import {
// 	BabylonLoader
// } from '../js/jsm/loaders/BabylonLoader';
// import {
// 	ColladaLoader
// } from '../js/jsm/loaders/ColladaLoader';
// import {
// 	FBXLoader
// } from '../js/jsm/loaders/FBXLoader';
// import {
// 	OBJLoader
// } from '../js/jsm/loaders/OBJLoader';
// import {
// 	PlayCanvasLoader
// } from '../js/jsm/loaders/PlayCanvasLoader';
// import {
// 	PLYLoader
// } from '../js/jsm/loaders/PLYLoader';
// import {
// 	STLLoader
// } from '../js/jsm/loaders/STLLoader';
// import {
// 	TDSLoader
// } from '../js/jsm/loaders/TDSLoader';
// import {
// 	VRMLLoader
// } from '../js/jsm/loaders/VRMLLoader';

// import {
// 	GLTFLoader
// } from '../js/exports/GLTFLoader';

import {
	HDRCubeTextureLoader
} from '../jsm/loaders/HDRCubeTextureLoader';
import {
	PMREMGenerator
} from '../jsm/pmrem/PMREMGenerator';
import {
	PMREMCubeUVPacker
} from '../jsm/pmrem/PMREMCubeUVPacker';
import {
	GLTFLoader
} from './GLTFLoader';
import {
	OBJLoader
} from '../jsm/loaders/OBJLoader';
// import {
// 	EquirectangularToCubeGenerator
// } from '../js/jsm/loaders/EquirectangularToCubeGenerator';
// import JSZipUtils from 'jszip-utils';
// import JSZip from 'jszip';
// import * as COMMAND from './commondsSet';
// import * as IO from './io/index.js';
// let GT3D = new IO.GT3D();
// import Utils from './utils';
import {DRACOLoader} from '../jsm/loaders/DRACOLoader';
let dracoLoader=new DRACOLoader();
DRACOLoader.setDecoderPath("./draco/")
const textureLoader = new THREE.TextureLoader();
class Loader {
	constructor(editor) {
		this.editor = editor;
	}

	static loadOneTexture(url) {
		return new Promise(resolve => {
			textureLoader.load(url, function (texture) {
				resolve(texture);
			});
		});
	}

	// static loadOne2SixTexture(url, renderer, options) {
	// 	return new Promise((resolve, reject) => {
	// 		new THREE.TextureLoader().load(url, function (texture) {
	// 			let cubeGenerator = new EquirectangularToCubeGenerator(texture, {
	// 				resolution: 512
	// 			});
	// 			cubeGenerator.update(renderer);

	// 			let pmremGenerator = new PMREMGenerator(cubeGenerator.renderTarget.texture);
	// 			pmremGenerator.update(renderer);

	// 			let pmremCubeUVPacker = new PMREMCubeUVPacker(pmremGenerator.cubeLods);
	// 			pmremCubeUVPacker.update(renderer);

	// 			let envMap = pmremCubeUVPacker.CubeUVRenderTarget.texture;
	// 			pmremGenerator.dispose();
	// 			pmremCubeUVPacker.dispose();
	// 			resolve({
	// 				background: cubeGenerator.renderTarget,
	// 				envMap: envMap,
	// 				options
	// 			});
	// 		});
	// 	});
	// }

	// static generateSixtextureByOne(texture, renderer) {
	// 	let cubeGenerator = new EquirectangularToCubeGenerator(texture, {
	// 		resolution: 512
	// 	});
	// 	cubeGenerator.update(renderer);

	// 	let pmremGenerator = new PMREMGenerator(cubeGenerator.renderTarget.texture);
	// 	pmremGenerator.update(renderer);

	// 	let pmremCubeUVPacker = new PMREMCubeUVPacker(pmremGenerator.cubeLods);
	// 	pmremCubeUVPacker.update(renderer);

	// 	let envMap = pmremCubeUVPacker.CubeUVRenderTarget.texture;
	// 	pmremGenerator.dispose();
	// 	pmremCubeUVPacker.dispose();
	// 	return {
	// 		background: cubeGenerator.renderTarget,
	// 		envMap: envMap
	// 	};
	// }

	static packTexture(texture, renderer, size) {
		let pmremGenerator = new PMREMGenerator(texture, size);
		pmremGenerator.update(renderer);

		let pmremCubeUVPacker = new PMREMCubeUVPacker(pmremGenerator.cubeLods);
		pmremCubeUVPacker.update(renderer);
	}

	// static loadGltfModel(sceneInfo) {
	// 	let Loader = new GLTFLoader();
	// 	return new Promise((resolve, reject) => {
	// 		Loader.load(sceneInfo.url, scene => {
	// 			resolve(scene);
	// 		});
	// 	});
	// }

	// static loadGt3dModel(data, baseUrl) {
	// 	let Loader = new GLTFLoader();
	// 	return new Promise((resolve, reject) => {
	// 		Loader.parse(data, baseUrl, scene => {
	// 			resolve(scene);
	// 		});
	// 	});
	// }

	// static loadFBXModel(sceneInfo) {
	// 	let loader = new FBXLoader();
	// 	return new Promise((resolve, reject) => {
	// 		loader.load(sceneInfo.url, scene => {
	// 			resolve(scene);
	// 		});
	// 	});
	// }

	// static loadObjectModel(sceneInfo) {
	// 	let objLoader = new OBJLoader();
	// 	return new Promise((resolve, reject) => {
	// 		objLoader.load(sceneInfo.url, function (object) {
	// 			resolve(object);
	// 		});
	// 	});
	// }

	static loadCubeHDREnvirment(urls,renderer) {
		let hdrUrls = urls;
		return new Promise((resolve, reject) => {
			let hdrTextureLoader = new HDRCubeTextureLoader();
			hdrTextureLoader.load(THREE.UnsignedByteType, hdrUrls, function (hdrCubeMap) {
				Loader.packTexture(hdrCubeMap, renderer, 256);
				hdrCubeMap.minFilter = THREE.NearestFilter;
				hdrCubeMap.magFilter = THREE.NearestFilter;
				resolve(hdrCubeMap);
			});
		});
	}
	static loadTexture(path, textureOpts={}) {
        return new Promise((resolve) => {
            textureLoader.load(path, function (texture) {
                if(textureOpts.NearestFilter){
                    texture.magFilter = THREE.NearestFilter;
                    texture.minFilter = THREE.NearestFilter;
                }
                resolve(texture);
            })
        })
    };
    static loadTextureEnvMap(path) {
        return new Promise((resolve) => {
            textureLoader.load(path, function (texture) {
                texture.mapping = THREE.SphericalReflectionMapping;
                resolve(texture);
            })
        })
    };
	// static loadCubeEnvirment(urls) {
	// 	return new Promise((resolve, reject) => {
	// 		let cubeTextureLoader = new THREE.CubeTextureLoader();
	// 		cubeTextureLoader.load(urls, function (cubeMap) {
	// 			resolve(cubeMap);
	// 		});
	// 	});
	// }

	// static loadJSONModel(sceneInfo) {
	// 	let objectLoader = new THREE.ObjectLoader();
	// 	objectLoader.setCrossOrigin('*');
	// 	return new Promise((resolve, reject) => {
	// 		objectLoader.load(sceneInfo.url, function (object) {
	// 			resolve(object);
	// 		});
	// 	});
	// }

	// static loadZipModel(sceneInfo) {
	// 	let zipLoader = new JSZip();
	// 	let fileMap = {};
	// 	let pending = [];
	// 	let manager = new THREE.LoadingManager();
	// 	manager.setURLModifier(urlResolver);

	// 	function urlResolver(url) {
	// 		return fileMap[url] ? fileMap[url] : url;
	// 	}

	// 	function find(fileMap, query) {
	// 		if (typeof query === 'string') {
	// 			query = new RegExp(query.replace(/\./g, '\\.'));
	// 		}

	// 		let files = [];

	// 		for (let key in fileMap) {
	// 			if (key.match(query) !== null) {
	// 				files.push(key);
	// 			}
	// 		}

	// 		return files;
	// 	}
	// 	// more files !
	// 	return new Promise(resolve => {
	// 		JSZipUtils.getBinaryContent(sceneInfo.url, function (err, data) {
	// 			if (err) {
	// 				throw err; // or handle err
	// 			}
	// 			let baseUrl = 'blob:' + THREE.LoaderUtils.extractUrlBase(sceneInfo.url);
	// 			zipLoader.loadAsync(data).then(function (zip) {
	// 				for (let i in zip.files) {
	// 					let file = zip.files[i];
	// 					let fileName = i;
	// 					if (!file.dir) {
	// 						// pending
	// 						pending.push(
	// 							new Promise(resolve2 => {
	// 								zipLoader
	// 									.file(fileName)
	// 									.async('blob')
	// 									.then(data => {
	// 										fileMap[baseUrl + fileName] = URL.createObjectURL(data);
	// 										resolve2();
	// 									});
	// 							})
	// 						);
	// 					}
	// 				}

	// 				Promise.all(pending).then(() => {
	// 					let pending1 = [];
	// 					let objects = [];
	// 					objects.image = [];
	// 					let file = find(fileMap, /\.(gltf|glb)$/i);
	// 					//FBX模型
	// 					let file2 = find(fileMap, /\.(fbx)$/i);
	// 					let file4 = find(fileMap, /\.stl/);
	// 					let file5 = find(fileMap, /\.obj/);
	// 					let file6 = find(fileMap, /\.json/);
	// 					let file7 = find(fileMap, /\.3ds/i);
	// 					let file8 = find(fileMap, /\.jpg/i);
	// 					let file9 = find(fileMap, /\.png/i);
	// 					for (let i in file) {
	// 						pending1.push(
	// 							new Promise((resolveX, reject) => {
	// 								new GLTFLoader(manager).load(file[i], function (gltf) {
	// 									gltf.type = 'gltf';
	// 									objects.push(gltf);
	// 									resolveX(gltf);
	// 								});
	// 							})
	// 						);
	// 					}
	// 					for (let i in file2) {
	// 						pending1.push(
	// 							new Promise((resolveX, reject) => {
	// 								new FBXLoader(manager).load(file2[i], function (fbx) {
	// 									fbx.type = 'fbx';
	// 									objects.push(fbx);
	// 									resolveX(fbx);
	// 								});
	// 							})
	// 						);
	// 					}
	// 					for (let i in file4) {
	// 						pending1.push(
	// 							new Promise((resolveX, reject) => {
	// 								new STLLoader(manager).load(file4[i], function (stl) {
	// 									stl.type = stl;
	// 									objects.push(stl);
	// 									resolveX(stl);
	// 								});
	// 							})
	// 						);
	// 					}
	// 					for (let i in file5) {
	// 						pending1.push(
	// 							new Promise((resolveX, reject) => {
	// 								new OBJLoader(manager).load(file5[i], function (obj) {
	// 									obj.type = 'obj';
	// 									objects.push(obj);
	// 									resolveX(obj);
	// 								});
	// 							})
	// 						);
	// 					}
	// 					for (let i in file6) {
	// 						pending1.push(
	// 							new Promise((resolveX, reject) => {
	// 								new THREE.ObjectLoader(manager).load(file6[i], function (obj) {
	// 									obj.type = 'json';
	// 									objects.push(obj);
	// 									resolveX(obj);
	// 								});
	// 							})
	// 						);
	// 					}
	// 					for (let i in file7) {
	// 						pending1.push(
	// 							new Promise((resolveX, reject) => {
	// 								new TDSLoader(manager).load(file7[i], function (ds) {
	// 									ds.type = '3ds';
	// 									objects.push(ds);
	// 									resolveX(ds);
	// 								});
	// 							})
	// 						);
	// 					}
	// 					for (let i in file8) {
	// 						pending1.push(
	// 							new Promise((resolveX, reject) => {
	// 								let image = new Image();
	// 								image.src = fileMap[file8[i]];
	// 								objects.image.push(image);
	// 								resolveX(image);
	// 							})
	// 						);
	// 					}
	// 					for (let i in file9) {
	// 						pending1.push(
	// 							new Promise((resolveX, reject) => {
	// 								let image = new Image();
	// 								image.src = fileMap[file9[i]];
	// 								objects.image.push(image);
	// 								resolveX(image);
	// 							})
	// 						);
	// 					}
	// 					//加载纹理图片
	// 					Promise.all(pending1).then(() => {
	// 						resolve(objects);
	// 					});
	// 				});
	// 			});
	// 		});
	// 	});
	// }

	// static loadGT3D(path) {
	// 	return new Promise(resolve => {
	// 		IO.FileSystem.readFileArrayBuffer(path, true, gt3dBuffer => {
	// 			GT3D.inflate(gt3dBuffer).then(data => {
	// 				console.log('Data: ', data);
	// 				let resourcePath = THREE.LoaderUtils.extractUrlBase(path);
	// 				let gltfLoader = new GLTFLoader();
	// 				gltfLoader.parse(data, resourcePath, gltf => {
	// 					resolve(gltf);
	// 				});
	// 			});
	// 		});
	// 	});
	// }

	// //****** Load From Local ******//
	// loadFile(file, isYDZ) {
	// 	let _this = this;
	// 	let editor = this.editor;
	// 	let fileName = file.name;
	// 	let extension = fileName
	// 		.split('.')
	// 		.pop()
	// 		.toLowerCase();
	// 	let reader = new FileReader();

	// 	reader.addEventListener('progress', function (event) {
	// 		let size = '(' + Math.floor(event.total / 1000) + ' KB)';
	// 		let progress = Math.floor((event.loaded / event.total) * 100) + '%';
	// 		console.log('Loading', fileName, size, progress);
	// 	});

	// 	switch (extension) {
	// 		case '3ds':
	// 			reader.addEventListener(
	// 				'load',
	// 				function (event) {
	// 					let loader = new TDSLoader();
	// 					let object = loader.parse(event.target.result);
	// 					editor.execute(new COMMAND.AddObjectCommand(editor, object));
	// 				},
	// 				false
	// 			);
	// 			reader.readAsArrayBuffer(file);
	// 			break;
	// 		case 'babylon':
	// 			// reader.addEventListener(
	// 			// 	'load',
	// 			// 	function (event) {
	// 			// 		let contents = event.target.result;
	// 			// 		let json = JSON.parse(contents);
	// 			// 		let loader = new BabylonLoader();
	// 			// 		let scene = loader.parse(json);
	// 			// 		editor.execute(new COMMAND.SetSceneCommand(editor, scene));
	// 			// 	},
	// 			// 	false
	// 			// );
	// 			// reader.readAsText(file);
	// 			break;
	// 		case 'babylonmeshdata':
	// 			reader.addEventListener(
	// 				'load',
	// 				function (event) {
	// 					let contents = event.target.result;
	// 					let json = JSON.parse(contents);
	// 					let loader = new BabylonLoader();
	// 					let geometry = loader.parseGeometry(json);
	// 					let material = new THREE.MeshStandardMaterial();
	// 					let mesh = new THREE.Mesh(geometry, material);
	// 					mesh.name = fileName;
	// 					editor.execute(new COMMAND.AddObjectCommand(editor, mesh));
	// 				},
	// 				false
	// 			);
	// 			reader.readAsText(file);
	// 			break;
	// 		case 'dae':
	// 			reader.addEventListener(
	// 				'load',
	// 				function (event) {
	// 					let contents = event.target.result;
	// 					let loader = new ColladaLoader();
	// 					let collada = loader.parse(contents);
	// 					collada.scene.name = fileName;
	// 					editor.execute(new COMMAND.AddObjectCommand(editor, collada.scene));
	// 				},
	// 				false
	// 			);
	// 			reader.readAsText(file);
	// 			break;
	// 		case 'fbx':
	// 			reader.addEventListener(
	// 				'load',
	// 				function (event) {
	// 					let contents = event.target.result;
	// 					let loader = new FBXLoader();
	// 					let object = loader.parse(contents);
	// 					// object.name = fileName;
	// 					if (object.isObject3D && isYDZ) {
	// 						let scale = object.scale.clone();
	// 						object.scale.set(scale.x * 10, scale.y * 10, scale.z * 10);
	// 						object.position.y = 10;
	// 					}
	// 					console.log('object', object);
	// 					editor.execute(new COMMAND.AddObjectCommand(editor, object));
	// 				},
	// 				false
	// 			);
	// 			reader.readAsArrayBuffer(file);
	// 			break;
	// 		case 'glb':
	// 		case 'gltf':
	// 			reader.addEventListener(
	// 				'load',
	// 				function (event) {
	// 					let contents = event.target.result;
	// 					let loader = new GLTFLoader();
	// 					loader.parse(contents, '', function (result) {
	// 						result.scene.name = fileName;
	// 						console.log('result', result);
	// 						extension === 'gltf' && editor.ensureSceneData(result.scene, true);
	// 						editor.execute(new COMMAND.AddObjectCommand(editor, result.scene));
	// 					});
	// 				},
	// 				false
	// 			);
	// 			reader.readAsArrayBuffer(file);
	// 			break;
	// 		case 'gt3d':
	// 			reader.addEventListener(
	// 				'load',
	// 				function (event) {
	// 					let contents = event.target.result;
	// 					GT3D.inflate(contents).then(data => {
	// 						let gltfLoader = new GLTFLoader();
	// 						gltfLoader.parse(data, '', gltf => {
	// 							editor.ensureSceneData(gltf.scene, true);
	// 							if (editor.DCController) editor.DCController.ensureDiamondCustomScene(editor.scene);
	// 							editor.execute(new COMMAND.AddObjectCommand(editor, gltf.scene));
	// 						});
	// 					});
	// 				},
	// 				false
	// 			);
	// 			reader.readAsArrayBuffer(file);
	// 			break;
	// 		case 'json':
	// 			reader.addEventListener(
	// 				'load',
	// 				function (event) {
	// 					let contents = event.target.result;
	// 					let data = JSON.parse(contents);
	// 					console.log('Json:', data);
	// 					_this.handleJSON(editor, data, file, fileName);
	// 				},
	// 				false
	// 			);
	// 			reader.readAsText(file);
	// 			break;
	// 		case 'obj':
	// 			reader.addEventListener(
	// 				'load',
	// 				function (event) {
	// 					let contents = event.target.result;
	// 					let object = new OBJLoader().parse(contents);
	// 					object.name = fileName;
	// 					editor.execute(new COMMAND.AddObjectCommand(editor, object));
	// 				},
	// 				false
	// 			);
	// 			reader.readAsText(file);
	// 			break;
	// 		case 'playcanvas':
	// 			reader.addEventListener(
	// 				'load',
	// 				function (event) {
	// 					let contents = event.target.result;
	// 					let json = JSON.parse(contents);
	// 					let loader = new PlayCanvasLoader();
	// 					let object = loader.parse(json);
	// 					editor.execute(new COMMAND.AddObjectCommand(editor, object));
	// 				},
	// 				false
	// 			);
	// 			reader.readAsText(file);
	// 			break;
	// 		case 'ply':
	// 			reader.addEventListener(
	// 				'load',
	// 				function (event) {
	// 					let contents = event.target.result;
	// 					let geometry = new PLYLoader().parse(contents);
	// 					geometry.sourceType = 'ply';
	// 					geometry.sourceFile = file.name;
	// 					let material = new THREE.MeshStandardMaterial();
	// 					let mesh = new THREE.Mesh(geometry, material);
	// 					mesh.name = fileName;
	// 					editor.execute(new COMMAND.AddObjectCommand(editor, mesh));
	// 				},
	// 				false
	// 			);
	// 			reader.readAsArrayBuffer(file);
	// 			break;
	// 		case 'stl':
	// 			reader.addEventListener(
	// 				'load',
	// 				function (event) {
	// 					let contents = event.target.result;
	// 					let geometry = new STLLoader().parse(contents);
	// 					geometry.sourceType = 'stl';
	// 					geometry.sourceFile = file.name;
	// 					let material = new THREE.MeshStandardMaterial();
	// 					let mesh = new THREE.Mesh(geometry, material);
	// 					mesh.name = fileName;
	// 					editor.execute(new COMMAND.AddObjectCommand(editor, mesh));
	// 				},
	// 				false
	// 			);
	// 			reader.readAsBinaryString ? reader.readAsBinaryString(file) : reader.readAsArrayBuffer(file);
	// 			break;
	// 		case 'wrl':
	// 			reader.addEventListener(
	// 				'load',
	// 				function (event) {
	// 					let contents = event.target.result;
	// 					let result = new VRMLLoader().parse(contents);
	// 					editor.execute(new COMMAND.SetSceneCommand(editor, result));
	// 				},
	// 				false
	// 			);
	// 			reader.readAsText(file);
	// 			break;
	// 		case 'zip':
	// 			reader.addEventListener(
	// 				'load',
	// 				function (event) {
	// 					let contents = event.target.result;
	// 					_this.handleZip(editor, contents);
	// 				},
	// 				false
	// 			);
	// 			reader.readAsBinaryString(file);
	// 			break;
	// 		default:
	// 			alert('Unsupported file format (' + extension + ').');
	// 			break;
	// 	}
	// }
	// handleZip(editor, data) {
	// 	let zipLoader = new JSZip();
	// 	let reg = /\.(\w+)$/g;
	// 	let loader;
	// 	zipLoader.loadAsync(data).then(function (zip) {
	// 		let files = zip.files;
	// 		// console.log('files', files);
	// 		for (let fileName in files) {
	// 			// console.log('loadZip: ', fileName);
	// 			let suffix = fileName.match(reg)[0];
	// 			let file = files[fileName];
	// 			switch (suffix) {
	// 				// Todo: 处理逻辑待提出
	// 				case '.glb':
	// 				case '.gltf':
	// 					loader = new GLTFLoader();
	// 					zipLoader
	// 						.file(fileName)
	// 						.async('arraybuffer')
	// 						.then(contents => {
	// 							loader.parse(contents, '', function (result) {
	// 								result.scene.name = fileName;
	// 								suffix === '.gltf' && editor.ensureSceneData(result.scene, true);
	// 								editor.execute(new COMMAND.AddObjectCommand(editor, result.scene));
	// 							});
	// 						});
	// 					break;
	// 				case '.gt3d':
	// 					loader = new GLTFLoader();
	// 					zipLoader
	// 						.file(fileName)
	// 						.async('arraybuffer')
	// 						.then(contents => {
	// 							GT3D.inflate(contents).then(data => {
	// 								loader.parse(data, '', gltf => {
	// 									editor.ensureSceneData(gltf.scene, true);
	// 									editor.execute(new COMMAND.AddObjectCommand(editor, gltf.scene));
	// 								});
	// 							});
	// 						});
	// 					break;
	// 				case '.json':
	// 					zipLoader
	// 						.file(fileName)
	// 						.async('string')
	// 						.then(contents => {
	// 							let data = JSON.parse(contents);
	// 							_this.handleJSON(editor, data, file, fileName);
	// 						});
	// 					break;
	// 				default:
	// 					break;
	// 			}
	// 		}
	// 	});
	// }
	// handleJSON(editor, data, file, fileName) {
	// 	if (data.metadata === undefined) {
	// 		// 2.0
	// 		data.metadata = {
	// 			type: 'Geometry'
	// 		};
	// 	}
	// 	if (data.metadata.type === undefined) {
	// 		// 3.0
	// 		data.metadata.type = 'Geometry';
	// 	}
	// 	if (data.metadata.formatVersion !== undefined) {
	// 		data.metadata.version = data.metadata.formatVersion;
	// 	}
	// 	let loader, result, mesh;
	// 	switch (data.metadata.type.toLowerCase()) {
	// 		case 'buffergeometry':
	// 			loader = new THREE.BufferGeometryLoader();
	// 			result = loader.parse(data);
	// 			mesh = new THREE.Mesh(result);
	// 			editor.execute(new COMMAND.AddObjectCommand(editor, mesh));
	// 			break;
	// 		case 'geometry':
	// 			loader = new THREE.ObjectLoader();
	// 			result = loader.parse(data);
	// 			let geometry = result.geometry;
	// 			let material;
	// 			if (result.materials !== undefined) {
	// 				if (result.materials.length > 1) {
	// 					material = new THREE.MultiMaterial(result.materials);
	// 				} else {
	// 					material = result.materials[0];
	// 				}
	// 			} else {
	// 				material = new THREE.MeshStandardMaterial();
	// 			}
	// 			geometry.sourceType = 'ascii';
	// 			geometry.sourceFile = file.name;
	// 			if (geometry.animation && geometry.animation.hierarchy) {
	// 				mesh = new THREE.SkinnedMesh(geometry, material);
	// 			} else if (geometry.bones) {
	// 				mesh = new THREE.SkinnedMesh(geometry, material);
	// 			} else {
	// 				mesh = new THREE.Mesh(geometry, material);
	// 			}
	// 			mesh.name = fileName;
	// 			editor.execute(new COMMAND.AddObjectCommand(editor, mesh));
	// 			break;
	// 		case 'object':
	// 			loader = new THREE.ObjectLoader();
	// 			loader.setCrossOrigin('*');
	// 			loader.parse(data, function (result) {
	// 				if (result instanceof THREE.Scene) {
	// 					editor.execute(new COMMAND.SetSceneCommand(editor, result));
	// 				} else {
	// 					editor.execute(new COMMAND.AddObjectCommand(editor, result));
	// 				}
	// 				editor.ensureSceneData(result, true);
	// 			});
	// 			break;
	// 	}
	// }
	// importGLTF(fileMap) {
	// 	let rootFile;
	// 	let rootPath;
	// 	Array.from(fileMap).forEach(([path, file]) => {
	// 		if (file.name.match(/\.(gltf|glb)$/)) {
	// 			rootFile = file;
	// 			rootPath = path.replace(file.name, '');
	// 		}
	// 	});
	// 	if (!rootFile) {
	// 		console.error('No .gltf or .glb asset found.');
	// 	}
	// 	const fileURL = typeof rootFile === 'string' ? rootFile : URL.createObjectURL(rootFile);
	// 	return this.localGLTFLoader(fileURL, rootPath, fileMap);
	// }
	// localGLTFLoader(url, rootPath, assetMap) {
	// 	const baseURL = THREE.LoaderUtils.extractUrlBase(url);
	// 	// Load.
	// 	return new Promise((resolve, reject) => {
	// 		const manager = new THREE.LoadingManager();
	// 		// Intercept and override relative URLs.
	// 		manager.setURLModifier((url, path) => {
	// 			const normalizedURL = rootPath + url.replace(baseURL, '').replace(/^(\.?\/)/, '');
	// 			if (assetMap.has(normalizedURL)) {
	// 				const blob = assetMap.get(normalizedURL);
	// 				const blobURL = URL.createObjectURL(blob);
	// 				blobURLs.push(blobURL);
	// 				return blobURL;
	// 			}
	// 			return (path || '') + url;
	// 		});

	// 		const loader = new GLTFLoader(manager);
	// 		loader.setCrossOrigin('anonymous');

	// 		const blobURLs = [];

	// 		loader.load(
	// 			url,
	// 			gltf => {
	// 				const scene = gltf.scene || gltf.scenes[0];
	// 				let editor = this.editor;
	// 				editor.ensureSceneData(gltf.scene, true);
	// 				if (editor.DCController) editor.DCController.ensureDiamondCustomScene(editor.scene);
	// 				editor.execute(new COMMAND.AddObjectCommand(editor, scene));
	// 				resolve(gltf);
	// 			},
	// 			undefined,
	// 			reject
	// 		);
	// 	});
	// }
	static loadGltfModel(sceneInfo) {
		let Loader = new GLTFLoader();
		
		Loader.setDRACOLoader(dracoLoader);
		Loader.setCrossOrigin("anonymous")
		return new Promise((resolve, reject) => {
			Loader.load(sceneInfo.url, scene => {
				resolve(scene);
			});
		});
	}
	static loadObjectModel(sceneInfo) {
		let objLoader = new OBJLoader();
		return new Promise((resolve, reject) => {
			objLoader.load(sceneInfo.url, function (object) {
				resolve(object);
			});
		});
	}
}
export default Loader;